import { MILLISECONDS_IN_SECONDS } from 'src/Constants/numeric'

const STORAGE_KEY = 'pendingGoogleSignupSurvey'
const PENDING_TTL_MINUTES = 15
const SECONDS_IN_MINUTE = 60
const PENDING_TTL_MS =
  PENDING_TTL_MINUTES * SECONDS_IN_MINUTE * MILLISECONDS_IN_SECONDS

export const persistPendingGoogleSignupSurvey = (): void => {
  sessionStorage.setItem(STORAGE_KEY, String(Date.now()))
}

export const hasPendingGoogleSignupSurvey = (): boolean => {
  const startedAt = Number(sessionStorage.getItem(STORAGE_KEY))

  return Boolean(startedAt) && Date.now() - startedAt < PENDING_TTL_MS
}

export const clearPendingGoogleSignupSurvey = (): void => {
  sessionStorage.removeItem(STORAGE_KEY)
}
